<template>
  <donut-errors-base :code-chars="['O', 'PS']">
    <div class="t-lg m-tx1">The page took too long to load. You can try reloading the page in a few minutes.</div>
    <div class="t-lg">
      <span>Please&#32;</span>
      <donut-contact-support link-text="contact us" link-class="t-lg" intercom-id="general-retry" />
      <span>&#32;if you continue to have issues.</span>
    </div>
  </donut-errors-base>
</template>
